import logo from '../../images/Mobile2Logo.svg';
import { HiOutlineChartBar, HiOutlineTicket } from 'react-icons/hi';
import { TiHomeOutline } from 'react-icons/ti';
import { NavLink, Outlet } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { MdNotificationsNone, MdOutlineMarkChatUnread } from 'react-icons/md';
import { useState, useEffect, useContext, useRef } from 'react';
import { componentLoadingActive, ComponentLoadingScreen, PageLoadingScreen } from '../../components/Background';
import { ExpandableBubbleSidebar, ticketCategoryConfigs, ticketStatusConfigs } from '../../components/TicketComponents';
import { timePassedChat, TryMeButton } from '../../utils';
import { NotificationContext } from '../../contexts/NotificationContexts';
import { TbLayoutSidebarLeftCollapse, TbPinned, TbPinnedFilled } from 'react-icons/tb';
import { IoAtOutline, IoSettingsOutline } from 'react-icons/io5';
import { AccountContext } from '../../contexts/AccountContexts';
import { CgPlayListRemove } from 'react-icons/cg';
import { VscSearch } from 'react-icons/vsc';
import { AiOutlineClose } from 'react-icons/ai';
import { RiAppsLine } from 'react-icons/ri';
import { PiUsersThreeBold, PiWarningBold } from 'react-icons/pi';
import { requestCountNewWarnings } from '../../requests/warning_requests';
import { requestChats, requestPinTicket, requestRemoveTicketFromChat, requestRemoveTicketsFromChat } from '../../requests/chat_requests';
import { GenericErrorModal } from '../../components/ErrorComponents';
import { ContentContext } from '../../contexts/ContentContext';
import { useTranslation } from 'react-i18next';
import { Header } from '../../components/NavBar';
import { PermissionContext } from '../../contexts/PermissionContexts';
import { setupLinks, setupMenuPermissions } from '../../entries';
import { BiCategory } from 'react-icons/bi';
import { ConnectionLostMessage, CopiedToClipboard } from '../../components/ModalComponents';
import { LuGamepad2 } from 'react-icons/lu';
import { AdminFooter } from '../../components/FooterComponents';
import { requestNotifications } from '../../requests/notification_requests';
import { RemovePinnedTicketModal } from '../../components/DeveloperComponents';
import { requestFetchEmployeeAnnouncementReads } from '../../requests/setup_requests';


function Sidebar() {
    const { user, isTempUser } = useContext(AccountContext)
    const navigator = useNavigate()
    if (isTempUser) {
        navigator("/home")
        return <></>
    }
    else if (user === null) {
        navigator("/home")
        return <></>
    }
    else if (user?.class === "user") {
        navigator("/member/home")
        return <></>
    }



    return <>
        <TryMeButton />

        <ConnectionLostMessage />
        <CopiedToClipboard />
        <GenericErrorModal />
        <Drawer>
            <Header />
            <div className='flex flex-col items-center w-full min-h-screen'>
                <Outlet />
            </div>
            <AdminFooter />
        </Drawer>
    </>
}


function Drawer(props) {
    const { t } = useTranslation('sidebar')
    const { hasPermission } = useContext(PermissionContext)
    const { user } = useContext(AccountContext)
    const { socket, playerAnnouncements, employeeAnnouncements, newMessageNotifications, numberNotifications, numberWarningNotifications, isSidebar, setIsSidebar } = useContext(NotificationContext)
    const [nUnreadChat, setNUnreadChat] = useState(0)
    const [tagged , setTagged] = useState(0)
    const [notifications, setNotifications] = useState([])
    const [newTickets, setNewTickets] = useState([])
    const [nUnreadAnnouncement, setNUnreadAnnouncement] = useState(0)
    const [nAnnouncementReads, setNAnnouncementReads] = useState(0)

    const [nNewWarnings, setNNewWarnings] = useState(0)
    const canViewWarnings = hasPermission("warnings:view")
    // Setup opens on the first of its pages the user may see.
    const firstSetupLink = setupLinks.find((link) => hasPermission(link.permission))
    const canViewSetup = !!firstSetupLink && setupMenuPermissions.some(hasPermission)

    useEffect(() => {
        requestNotifications({ nFirst: 30, unread_only: true })
        .then((data) => {
            setNotifications(data.notifications)
        })
    },[numberNotifications])

    useEffect(() => {
        if (!canViewWarnings) return
        requestCountNewWarnings({})
            .then((data) => setNNewWarnings(data.n_new))
            .catch((error) => console.error(error.status, error.message))
    }, [numberNotifications, numberWarningNotifications, canViewWarnings])

    useEffect(() => {
        const totalUnread = notifications.filter(notification => notification.type === "new_message");
        setNUnreadChat(totalUnread);
        setTagged(Object.values(newMessageNotifications).filter(item => item?.tagged).length)
        setNewTickets(notifications.filter(notification => notification.type === "assignment"))
        setNUnreadAnnouncement(employeeAnnouncements.length - nAnnouncementReads.length)
    },[newMessageNotifications, notifications, playerAnnouncements, employeeAnnouncements, nAnnouncementReads,socket])

    useEffect(() => {
        socket.on("announcement_unread_count", (data) => {
            setNUnreadAnnouncement(data.unread)
        });
        return () => socket.off("announcement_unread_count");
    }, [socket]);

    useEffect(() => {
        requestFetchEmployeeAnnouncementReads({}).then(async(data) => {
            setNAnnouncementReads(data.announcements.filter(read => read.user_id === user.id && employeeAnnouncements.some(announcement => announcement.id === read.announcement_id)))
        })
    }, [employeeAnnouncements, user]);

    return (
        <> 
            <div className="drawer lg:drawer-open">
                <input id="my-drawer-2" type="checkbox" className="drawer-toggle" />
                <div className="drawer-content flex flex-col items-center bg-gray-100 dark:bg-gray-800 relative text-gray-800 dark:text-gray-300">
                    <PageLoadingScreen />
                    {props.children}
                </div>
                <div className="drawer-side z-[100]">
                    <label htmlFor="my-drawer-2" aria-label="close sidebar" className="drawer-overlay"></label>
                    {
                        !isSidebar ?
                            <TicketsSidebar changeSidebar={setIsSidebar} />
                            :
                            <ul className="menu bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-300 min-h-full w-72 p-4 gap-2">
                                <div className='flex w-full justify-center mb-5'>
                                    <a className='block' href='/' target='_self'>

                                        <img
                                            src={logo} width={150}
                                        />
                                    </a>
                                </div>

                                <LinkComponent to="/admin/dashboard" notification={nUnreadAnnouncement} name={t("Dashboard")} icon={<TiHomeOutline />} />
                                <LinkComponent to="/admin/ticket" nUnreadChat={nUnreadChat.length} tagged={tagged} notification={newTickets.length} name={t("Tickets")} icon={<HiOutlineTicket />} />
                                <LinkComponent to="/admin/notifications" name={t("Notifications")} notification={numberNotifications} icon={<MdNotificationsNone />} />
                                {
                                    canViewWarnings &&
                                    <LinkComponent to="/admin/warnings" name={t("Warnings")} notification={nNewWarnings} icon={<PiWarningBold />} />
                                }
                                {
                                    hasPermission("members:view") &&
                                    <LinkComponent to="/admin/members" name={t("Players")} icon={<LuGamepad2 />} />
                                }
                                {
                                    hasPermission("users:view") &&
                                    <LinkComponent to="/admin/users" name={t("Users")} icon={<PiUsersThreeBold />} />
                                }
                                {
                                    hasPermission("stats:page_view") &&
                                    <LinkComponent to="/admin/statistics" name={t("Statistics")} icon={<HiOutlineChartBar />} />
                                }
                                {
                                    canViewSetup &&
                                    <LinkComponent to="/admin/setup" landing={`/admin/setup/${firstSetupLink.link}`} name={t("Setup")} icon={<RiAppsLine />} />
                                }
                                <LinkComponent to="/admin/settings" name={t("Settings")} icon={<IoSettingsOutline />} />

                            </ul>
                    }
                </div>
            </div>
        </>
    )
}


const TicketsSidebar = ({ changeSidebar }) => {
    const { t } = useTranslation('sidebar')

    const { user, userPreferences } = useContext(AccountContext)
    const { socket, chatTickets, setChatTickets, newMessageNotifications } = useContext(NotificationContext)
    const { openErrorModal } = useContext(ContentContext)
    const [filteredIds, setFilteredIds] = useState([])
    const [hasResolved, setHasResolved] = useState(false)
    const [hasClosed, setHasClosed] = useState(false)
    const [showCloseAllClosed, setShowCloseAllClosed] = useState(false)
    const [showCloseAllResolved, setShowCloseAllResolved] = useState(false)
    const [showCloseAllChats, setShowCloseAllChats] = useState(false)
    const [showPinned, setShowPinned] = useState(true)
    const [onlyPinned, setOnlyPinned] = useState(false)

    const navigator = useNavigate()

    const [showUnreadOnly, setShowUnreadOnly] = useState(false)

    const closeAllClosedButtonRef = useRef(null)
    const closeAllResolvedButtonRef = useRef(null)
    const closeAllChatsButtonRef = useRef(null)


    useEffect(() => {

        componentLoadingActive(true, 'sidebar-chats')
        requestChats({ userId: user.id }).then((data) => {
            // setChatTickets(data.tickets.sort((b, a) => parseInt(a.lastUpdated) - parseInt(b.lastUpdated)))

            let sortedByStatus = {
                "NEW TICKET": [],
                "WAITING DEV": [],
                "ON HOLD": [],
                "REPLIED": [],
                "RESOLVED": [],
                "CLOSED": []
            }

            for (let i = 0; i < data.tickets.length; i++) {
                let ticket = data.tickets[i]
                sortedByStatus[ticket.status].push(ticket)
            }

            let sortedByUpdate = {}
            for (const [status, tickets] of Object.entries(sortedByStatus)) {
                sortedByUpdate[status] = tickets.sort((b, a) => parseInt(a.lastUpdated) - parseInt(b.lastUpdated))
            }

            let sorted = []

            sorted.push(...sortedByUpdate["NEW TICKET"])
            sorted.push(...sortedByUpdate["WAITING DEV"])
            sorted.push(...sortedByUpdate["ON HOLD"])
            sorted.push(...sortedByUpdate["REPLIED"])
            sorted.push(...sortedByUpdate["RESOLVED"])
            sorted.push(...sortedByUpdate["CLOSED"])
            setChatTickets(sorted)

            componentLoadingActive(false, 'sidebar-chats')
        }).catch((error) => {
            console.error(error.status, error.message)
            openErrorModal(error)
            componentLoadingActive(false, 'sidebar-chats')
        })

    }, [])

    useEffect(() => {
        socket.on("ticket_pinned", ({ ticket_id, pinned }) => {
            setChatTickets(prev =>
            prev.map(t =>
                t.id === ticket_id ? { ...t, pinned: pinned } : t
            )
            );
        });

        return () => {
            socket.off("ticket_pinned");
        };
    }, []);


    const handleSidebarClick = (e) => {
        e.preventDefault()
        changeSidebar((prev) => !prev)
    }

    const handleTicketsClick = (e) => {
        e.preventDefault()
        navigator("/admin/ticket")
    }

    useEffect(() => {

        const checkCompleted = (tickets, status) => {
            for (let i = 0; i < tickets.length; i++) {
                if (tickets[i].status === status) {
                    return true
                }
            }
            return false
        }

        setHasResolved(checkCompleted(chatTickets, "RESOLVED"))
        setHasClosed(checkCompleted(chatTickets, "CLOSED"))
    }, [chatTickets])

    const handleClickCloseAllClosed = () => {
        setShowCloseAllClosed(true)
    }

    const handleClickCloseAllResolved = () => {
        setShowCloseAllResolved(true)
    }

    const handleClickCloseAllChats = () => {
        setShowCloseAllChats(true)
    }


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (closeAllClosedButtonRef.current && !closeAllClosedButtonRef.current.contains(event.target)) {
                setShowCloseAllClosed(false);
            }
            if (closeAllResolvedButtonRef.current && !closeAllResolvedButtonRef.current.contains(event.target)) {
                setShowCloseAllResolved(false);
            }
            if (closeAllChatsButtonRef.current && !closeAllChatsButtonRef.current.contains(event.target)) {
                setShowCloseAllChats(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleRemoveResolved = () => {
        let ticketIds = chatTickets.filter((ticket) => !ticket.pinned && ticket.status == "RESOLVED").map((ticket) => ticket.id)
        requestRemoveTicketsFromChat({ userId: user.id, ticketIds: ticketIds })
            .then(() => {
                setShowCloseAllResolved(false)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })

    }

    const handleRemoveClosed = () => {
        let ticketIds = chatTickets.filter((ticket) => !ticket.pinned && ticket.status == "CLOSED").map((ticket) => ticket.id)
        requestRemoveTicketsFromChat({ userId: user.id, ticketIds: ticketIds })
            .then(() => {
                setShowCloseAllClosed(false)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
    }

    const handleRemoveAllChats = () => {
        let ticketIds = chatTickets.filter((ticket) => !ticket.pinned).map((ticket) => ticket.id)
        requestRemoveTicketsFromChat({ userId: user.id, ticketIds: ticketIds })
            .then(() => {
                setShowCloseAllChats(false)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
    }


    const handleShowUnreadOnly = () => {
        setShowUnreadOnly((prev) => !prev)
    }

    return (
        <>
            <div className='flex flex-col bg-gray-50 dark:bg-gray-700 text-gray-800 dark:text-gray-300 w-72 min-h-full h-screen max-h-screen overflow-hidden p-1 gap-3 '>
                <div className='flex w-full justify-center mb-5'>
                    <a className='block' href='/' target='_self'>

                        <img
                            src={logo} width={150}
                        />
                    </a>
                </div>

                <div className='flex w-full justify-start items-center relative'>
                    {
                        showUnreadOnly ?
                            <span className='text-lg font-bold pl-2'>{t('Unread')}</span>
                            :
                            <span className='text-lg font-bold pl-2'>{t('Chats')}</span>
                    }
                    <button className='btn btn-sm bg-inherit text-primary dark:text-blue-600 border-2 w-9 p-0 border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' title={t('Open Sidebar')} onClick={handleSidebarClick}><TbLayoutSidebarLeftCollapse size={24} /></button>
                    <div className='ltr:ml-auto rtl:mr-auto flex gap-1 items-center'>
                        <div className='absolute flex top-full right-0'>
                        {/* Remove All Resolved */}
                        {
                            (hasResolved && !showCloseAllResolved && !showCloseAllClosed && !showCloseAllChats && chatTickets.some(ticket => !ticket.pinned && ticket.status == "RESOLVED")) &&
                            <button className='btn btn-sm bg-inherit text-green-400 border-2 w-8 p-0 pt-[2px] border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' title={t('Remove All Resolved')} onClick={handleClickCloseAllResolved}><CgPlayListRemove size={20} /></button>
                        }
                        {
                            showCloseAllResolved &&
                            <button className='btn btn-sm bg-inherit text-green-400 border-2 px-2 p-0  border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' ref={closeAllResolvedButtonRef} onClick={handleRemoveResolved}>{t('Remove All Resolved')}</button>
                        }
                        {/* Remove All Closed */}
                        {
                            (hasClosed && !showCloseAllResolved && !showCloseAllClosed && !showCloseAllChats && chatTickets.some(ticket => !ticket.pinned && ticket.status == "CLOSED")) &&
                            <button className='btn btn-sm bg-inherit text-red-600 border-2 w-8 p-0 pt-[2px] border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' title={t('Remove All Closed')} onClick={handleClickCloseAllClosed}><CgPlayListRemove size={20} /></button>
                        }
                        {
                            showCloseAllClosed &&
                            <button className='btn btn-sm bg-inherit text-red-600 border-2 px-2 p-0  border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' ref={closeAllClosedButtonRef} onClick={handleRemoveClosed}>{t('Remove All Closed')}</button>
                        }
                        {/* Remove All  */}
                        {
                            (userPreferences && userPreferences.remove_all_chats_button && !showCloseAllChats && !showCloseAllResolved && !showCloseAllClosed && chatTickets.some(ticket => !ticket.pinned)) &&
                            <button className='btn btn-sm bg-inherit text-primary dark:text-blue-600 border-2 w-8 p-0 pt-[2px] border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' title={t('Remove All Chats')} onClick={handleClickCloseAllChats}><CgPlayListRemove size={20} /></button>
                        }
                        {
                            showCloseAllChats &&
                            <button className='btn btn-sm bg-inherit text-primary dark:text-blue-600 border-2 px-2 p-0  border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' ref={closeAllChatsButtonRef} onClick={handleRemoveAllChats}>{t('Remove All Chats')}</button>
                        }
                        </div>
                        <button className={`btn btn-sm ${showUnreadOnly ? "bg-gray-300 hover:bg-gray-400 dark:bg-gray-800 dark:hover:bg-gray-600" : "bg-inherit hover:bg-gray-200 dark:hover:bg-gray-600"} text-primary dark:text-blue-600 border-2 w-8 p-0 border-none shadow-none `} title={t('Toggle Unread')} onClick={handleShowUnreadOnly}><MdOutlineMarkChatUnread size={20} /></button>

                        <button className='btn btn-sm bg-inherit text-primary dark:text-blue-600 border-2 w-9 p-0 border-none shadow-none hover:bg-gray-200 dark:hover:bg-gray-600' title={t('Open Tickets Page')} onClick={handleTicketsClick}><HiOutlineTicket size={24} /></button>

                    </div>
                </div>
                <div className={`flex w-full px-2 ${(chatTickets.some(ticket => !ticket.pinned && ticket.status == "RESOLVED") || chatTickets.some(ticket => !ticket.pinned && ticket.status == "CLOSED") || (userPreferences && userPreferences.remove_all_chats_button && chatTickets.some(ticket => !ticket.pinned))) && "mt-6" }`}>
                    <QuickSearchBar queryItems={chatTickets} getData={setFilteredIds} />
                </div>
                    <div className='flex flex-col overflow-y-auto overflow-x-hidden overscroll-contain min-h-[720px] pb-12 relative'>
                        <ComponentLoadingScreen tag={"sidebar-chats"} />
                        <div className='flex justify-between'>
                            <span onClick={() => setShowPinned(!showPinned)} className='underline cursor-pointer ltr:pl-2 rtl:pr-2 hover:text-blue-500 select-none'>{showPinned ? t("Hide Pinned") : t('Show Pinned')}</span>
                            <span onClick={() => setOnlyPinned(!onlyPinned)} className={`px-2 text-white text-sm cursor-pointer tabs-boxed items-center justify-center flex tabs-bordered btn btn-xs border-none content-center mb-2 ${onlyPinned ? "bg-yellow-500 hover:bg-yellow-500 text-center font-bold" : "bg-gray-500 hover:bg-gray-500"}`}>{t('Only Pinned')}</span>
                        </div>
                        {
                            chatTickets.filter((ticket) => (onlyPinned ? ticket.pinned : !showPinned ? !ticket.pinned : true) && filteredIds.includes(ticket.id) && (showUnreadOnly ? !!newMessageNotifications[ticket.id] : true))
                            .sort((a, b) => {
                                if (a.pinned && !b.pinned) return -1;
                                if (!a.pinned && b.pinned) return 1;
                                return 0;
                            })
                            .map((ticket) =>
                                <SidebarTicket key={ticket.id} ticket={ticket} />
                            )
                        }
                        {
                            chatTickets.length === 0 &&
                            <span className='ltr:pl-2 rtl:pr-2 text-sm'>{t('No active chats')}</span>
                        }

                    </div>
                <div className='relative'>

                    <div className='relative'>

                        <div className='absolute bottom-3 bg-gradient-to-t from-gray-50 dark:from-gray-700 w-full h-[80px] pointer-events-none'>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export const QuickSearchBar = ({ queryItems, getData }) => {
    const { t } = useTranslation('common')

    const { devs, language } = useContext(AccountContext)
    const { categories, priorities } = useContext(ContentContext)
    const [query, setQuery] = useState("")
    const [queryResults, setQueryResults] = useState([])

    const handleInput = (e) => {
        setQuery(e.target.value)
    }

    const handleClear = (e) => {
        e.preventDefault()
        setQuery("")
    }

    const searchObjectValues = (q, item) => {
        let values = []
        values.push(item.name)
        values.push(item.id)
        values.push(item.email)
        if (item.category) {
            values.push(categories[item.category] ? (categories[item.category]?.locales?.[language] ? categories[item.category]?.locales[language] : t(categories[item.category]?.title))  : "#")
        }
        values.push(item.server)
        values.push(item.characterName)
        values.push(item.subject)
        values.push(item.description)
        values.push(t(item.status))

        values.push(item.priority)
        if (item.priority) {
            values.push(priorities[item.priority] ? t(priorities[item.priority].title) : "#")
        }
        if (item.assignedTo) {

            values.push(devs[item.assignedTo].name)
        }

        for (let i = 0; i < values.length; i++) {
            try {

                if (String(values[i]).toLowerCase().includes(String(q).toLowerCase())) {
                    return true
                }
            } catch {
            }
        }
        return false
    }

    useEffect(() => {
        getData((prev) => [...queryResults])
    }, [queryResults])

    useEffect(() => {
        let filteredItems = []

        for (let i = 0; i < queryItems.length; i++) {
            let found = searchObjectValues(query, queryItems[i])
            if (found) {
                filteredItems.push(queryItems[i].id)
            }
        }
        setQueryResults((prev) => [...filteredItems])
    }, [query, queryItems])


    return (
        <label className="input input-bordered flex items-center gap-2 w-full ltr:pl-2 rtl:pr-2 ltr:pr-1 rtl:pl-1 h-10 focus:outline-4 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300">
            <div className='text-[#64748b] dark:text-gray-400'>
                <VscSearch />
            </div>

            <input type="text" className="grow text-sm focus:outline-0 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" placeholder="Search" value={query} onInput={handleInput} />

            {
                query.trim() !== ""
                &&
                <button className='btn btn-sm btn-square bg-inherit border-none hover:bg-gray-200 dark:hover:bg-gray-600 p-0'
                    onClick={handleClear}
                >
                    <AiOutlineClose />
                </button>
            }

        </label>
    )
}


const SidebarTicket = ({ ticket }) => {
    const { t } = useTranslation('sidebar')

    const [numberNewMessages, setNumberNewMessages] = useState(0)
    const [numberNewNotes, setNumberNewNotes] = useState(0)
    const [tagged, setTagged] = useState(false)
    const [assignedDevConfig, setAssignedDevConfig] = useState(null)

    const { devs, language } = useContext(AccountContext)
    const { newMessageNotifications } = useContext(NotificationContext)
    const { categories, servers, priorities, deletedCategories } = useContext(ContentContext)

    const [justAdded, setJustAdded] = useState(false)

    const [showDelete, setShowDelete] = useState(false)
    const [open, setOpen] = useState(false)
    const removeButtonRef = useRef()


    useEffect(() => {
        if (newMessageNotifications[ticket.id]) {
            setNumberNewMessages(newMessageNotifications[ticket.id].n_unread_chat)
            setNumberNewNotes(newMessageNotifications[ticket.id].n_unread_notes)
            setTagged(newMessageNotifications[ticket.id].tagged)
        }
        else {
            setNumberNewMessages(0)
            setNumberNewNotes(0)
        }
    }, [newMessageNotifications])


    useEffect(() => {
        if (ticket.assignedTo) {
            if (devs[ticket.assignedTo]) {
                let config = {
                    avatar: devs[ticket.assignedTo].avatar,
                    status: devs[ticket.assignedTo].name,
                    email: devs[ticket.assignedTo].email,
                    class: "dev"
                }
                setAssignedDevConfig(config)
            }
        }
        else {
            setAssignedDevConfig(null)
        }

    }, [ticket, ticket.assignedTo])


    const handleRemove = (e) => {
        e.preventDefault()
        if(ticket.pinned) {
            setOpen(true)
        } else {
            requestRemoveTicketFromChat({ ticketId: ticket.id }).then(() => {
                setShowDelete(false)
            })
        }
    }

    const handleClickRemove = (e) => {
        e.preventDefault()
        setShowDelete((prev) => !prev)
    }

    useEffect(() => {
        if (ticket.gotMessageAt && (Date.now() - ticket.gotMessageAt) < 10000) {
            setJustAdded(true)
            setTimeout(() => { setJustAdded(false) }, 10000)
        }
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (removeButtonRef.current && !removeButtonRef.current.contains(event.target)) {
                setShowDelete(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClick = () => {
        setJustAdded(false)
    }

    const categoryConfig = {
        status: categories[ticket.category] ? (categories[ticket.category]?.locales?.[language] ? categories[ticket.category]?.locales[language] : categories[ticket.category].title) : deletedCategories[ticket.category] ? deletedCategories[ticket.category].title : "unk",
        style: categories[ticket.category] ? categories[ticket.category].style : deletedCategories[ticket.category] ? deletedCategories[ticket.category].style : "bg-primary text-white",
        icon: ticketCategoryConfigs[ticket.category] ? ticketCategoryConfigs[ticket.category].icon : <BiCategory />
    }


    return (
        <div>
        <RemovePinnedTicketModal open={open} setOpen={setOpen} ticketId={ticket.id} />  
        <NavLink className={({ isActive }) => `flex w-full group/main rounded-lg ${isActive ? "bg-[#bfdbfe] dark:bg-[#bfdbfe]/30" : ""}  cursor-default select-none hover:bg-gray-200 dark:hover:bg-gray-600 ${justAdded && "bg-green-100 dark:bg-green-800/60"} py-1`}
            type="radio"
            to={`/admin/${ticket.fetch_code}/edit`}
            onClick={handleClick}
        >            
            <div className={`flex peer`}>
                <div className={`w-2 ${priorities[ticket.priority] ? priorities[ticket.priority].style : "bg-gray-400 text-black"} rounded-lg relative group hover:w-36 transition-all duration-300`}>
                    <div className={`opacity-0 group-hover:opacity-100 transition-opacity  duration-300 truncate p-1 font-semibold text-xs flex flex-col items-center max-w-max justify-center gap-1`}>
                        {
                            ticket?.ticket_type === "member" ?
                                <>
                                    <span title={ticket.name} className={`border w-full max-w-24 px-1 text-center rounded-lg truncate border-gray-300 dark:border-gray-600 ${ticket?.banned ? "bg-red-600 text-white" : "bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white"} `}
                                    >
                                        <span className="truncate">{ticket.name}</span>
                                    </span>
                                </>
                                :
                                <>
                                    <span>
                                        {ticket.name}
                                    </span>
                                </>
                        }
                        <span className='font-semibold'>
                            {ticket.characterName}
                        </span>
                        <span className='font-semibold'>
                            {servers?.[ticket.server]?.title}
                        </span>
                    </div>

                </div>
            </div>
            <div className='flex flex-col w-full p-1 pb-2 gap-2 relative peer-hover:overflow-hidden'>
                <div className='absolute ltr:right-2 rtl:left-2 top-7 flex gap-[1px]'>
                    <div className={` border rounded-full w-5 h-5 bg-yellow-600 flex justify-center items-center text-white text-xs transition-all duration-300 ease-in-out
                    ${tagged ? "opacity-100" : "hidden opacity-0"}`} >
                        <span><IoAtOutline size={15} /></span>
                    </div>

                    <div className={` border rounded-full w-5 h-5 bg-yellow-600 flex justify-center items-center text-white text-xs transition-all duration-300 ease-in-out
                    ${numberNewNotes > 0 ? "opacity-100" : "hidden opacity-0"}`} >
                        <span>{numberNewNotes}</span>
                    </div>
                    <div className={` border rounded-full w-5 h-5 bg-green-600 dark:border-gray-600 flex justify-center items-center text-white text-xs transition-all duration-300 ease-in-out
                    ${numberNewMessages > 0 ? "opacity-100" : "hidden opacity-0"}`} >
                        <span>{numberNewMessages}</span>
                    </div>
                </div>
                <div className='absolute ltr:right-1 rtl:left-1 bottom-0 flex'>
                    {

                        showDelete ?
                            <span className='text-red-600 dark:text-red-500 text-xs bg-white dark:bg-gray-700 px-1 py-[1px] rounded-lg cursor-pointer'
                                ref={removeButtonRef}
                                onClick={handleRemove}
                            >
                                {t('Remove Chat')}
                            </span>
                            :
                            <span className='invisible group-hover/main:visible text-red-600 w-5 h-5 hover:scale-125 cursor-pointer '
                                onClick={handleClickRemove}
                            >
                                <CgPlayListRemove size={20} />
                            </span>
                    }
                </div>
                <div className='flex w-full justify-between'>
                    <span className={`ltr:ml-2 rtl:mr-2 font-semibold max-w-40 truncate ${ticket.banned ? "text-red-600 dark:text-red-500" : ""}`}>{ticket.subject}</span>
                    <div className='flex gap-2'> 
                        <span className={`${numberNewMessages > 0 && "text-green-600 dark:text-green-500"} text-sm`}>{timePassedChat(ticket.lastUpdated * 1000, t)}</span>
                        <span onClick={() => requestPinTicket({pinned: ticket.pinned ? false : true, ticketId: ticket.id})}
                            className={`text-xl mr-1 cursor-pointer hover:text-yellow-400 ${ticket?.pinned ? 'hover:-rotate-45' : "hover:rotate-45"}`}
                            >
                                {
                                    ticket?.pinned ? <TbPinnedFilled className='rotate-45 text-yellow-400' /> : <TbPinned />
                                }
                        </span>
                    </div>
                </div>
                <div className='flex w-full justify-start gap-2'>
                    <ExpandableBubbleSidebar config={categoryConfig} />
                    <ExpandableBubbleSidebar config={ticketStatusConfigs[ticket.status]} />
                    <ExpandableBubbleSidebar config={assignedDevConfig} />
                </div>

            </div>
        </NavLink>
        </div>
    )
}




function LinkComponent({ to, landing, name, icon, notification, tagged, nUnreadChat }) {
    const { t } = useTranslation('sidebar')
    const { setIsSidebar } = useContext(NotificationContext)
    const navigator = useNavigate()

    const handleClick = (e) => {
        if (name === t("Tickets")) {
            setIsSidebar(false)
        }
        else if (name === t("Setup")) {
            e.preventDefault()
            if (!window.location.pathname.startsWith("/admin/setup/")) {
                navigator(landing)
            }
        }
    }

    return <>
        <NavLink
            className="flex justify-start relative items-center gap-2 hover:bg-primary hover:text-white p-3 rounded-lg font-semibold text-base focus:text-white focus:bg-primary  active:text-white"
            type="radio"
            onClick={handleClick}
            style={({ isActive }) => {
                return {
                    background: isActive
                        ? "#145388"
                        : "",
                    color: isActive ? "rgb(250 250 250)" : "",
                };
            }}
            to={to}
        >
            <LinkIcon notification={notification} icon={icon} /> 
            {name}
            <div className='absolute right-2 space-y-1'>
                {tagged > 0 && <span className='bg-yellow-600 w-5 h-5 text-center items-center flex justify-center rounded-md'>{tagged}</span>}
                {nUnreadChat > 0 && <span className='bg-green-600 w-5 h-5 text-center items-center flex justify-center rounded-md'>{nUnreadChat}</span>}
            </div>
        </NavLink>
    </>
}


function LinkIcon({ icon, notification }) {
    return <div className='rounded-lg bg-white relative dark:bg-gray-800 p-2 text-black dark:text-gray-300 ltr:mr-1 rtl:ml-1'>
        {notification > 0 && <div className='absolute -right-2 -top-2 bg-red-600 w-5 h-5 text-center items-center flex justify-center rounded-md'>{notification}</div>}
        {icon}
    </div>
}

export default Sidebar;